import { SUPPORTED_LANGUAGES } from '../../const';

interface LanguageFlagProps {
  language: string;
}

const LanguageFlag = ({ language }: LanguageFlagProps) => {
  const supported = SUPPORTED_LANGUAGES.find((l) => l.value === language);

  if (!supported) {
    return <span className="text-sm uppercase text-neutral-50">{language}</span>;
  }

  return (
    <img src={supported.icon} alt={supported.label} title={supported.label} className="w-5 h-5" />
  );
};

export default LanguageFlag;
